module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/H6whk4/images/tell-you-no-lies_final.jpg?1690353150871",
      "alt": "This image is the cover for the book Tell You No Lies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tell You No Lies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When a teenage boy is found dead in a Cambridge park, three women are determined to keep their secrets hidden . . .")]), _c('br'), _c('br'), _vm._v(" Emma, a detective’s wife, watches the park outside her window where a body was discovered. She sees contagion everywhere—even in her new baby. Emma was there the night of the murder, but as her mind spirals, can she be certain about what took place?"), _c('br'), _c('br'), _vm._v(" Jenny’s son had fought with the victim at school and didn’t come home that night. The detective is Jenny’s son’s father. She knows she should say something to him. But will she?"), _c('br'), _c('br'), _vm._v(" Sandra is the victim’s grandmother. She’s aware that murder investigations focus close to home. Is she also hiding something?"), _c('br'), _c('br'), _vm._v(" Only the police seem to care about the boy or the circumstances of his death. And if they don’t uncover the truth soon, there may be more tragedy to come . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lynn Fraser\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0